import React, { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import PublicLayout from "./PublicLayout";
import { properties } from "../properties";
import NetworkCanvas from "./NetworkCanvas";

export default function ShowcaseNetworkGraph() {
    const navigate = useNavigate();
    const { key } = useParams();
    const [loading, setLoading] = useState(true);
    const [smallScreen] = useState(window.innerWidth < 768);

    if (smallScreen) {
        return (
            <PublicLayout>
                <div className="upload-main" style={{ textAlign: "center", padding: "60px 20px" }}>
                    <p style={{ fontSize: 14, color: "var(--ink-400)" }}>The network graph is best viewed on a larger screen.</p>
                    <button className="chpw-back" style={{ marginTop: 16, display: "inline-flex" }} onClick={() => navigate(`/showcase/${key}`)}>
                        <ArrowLeft size={14} />
                        Back to Showcase
                    </button>
                </div>
            </PublicLayout>
        );
    }

    return (
        <PublicLayout>
            <div className="upload-main">
                <button className="chpw-back" onClick={() => navigate(`/showcase/${key}`)}>
                    <ArrowLeft size={14} />
                    Back to Showcase
                </button>

                <h1 className="upload-page-heading">Research Network</h1>

                <div style={{ position: "relative", borderRadius: 12, overflow: "hidden", background: "#0f1a14", minHeight: "70vh" }}>
                    {loading && (
                        <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", zIndex: 1 }}>
                            <NetworkCanvas />
                            <p style={{ color: "#5ecfa0", fontSize: 13, marginTop: 12 }}>Building your network...</p>
                        </div>
                    )}
                    <iframe
                        title="graph"
                        src={`${properties.host}/sample/showcase/${key}/graph`}
                        onLoad={() => setTimeout(() => setLoading(false), 3000)}
                        style={{
                            display: loading ? "none" : "block",
                            width: "100%",
                            height: "75vh",
                            border: "none",
                            borderRadius: 12,
                        }}
                    />
                </div>
            </div>
        </PublicLayout>
    );
}
